var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "800"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "rounded-0",
          attrs: {
            "color": "secondary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("수정하기")])];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.title) + " "), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-card-text', [_c('v-data-table', {
    staticClass: "mt-4",
    attrs: {
      "item-key": "tempId",
      "items": _vm.items,
      "headers": _vm.headers,
      "show-select": "",
      "single-select": "",
      "hide-default-footer": "",
      "disable-sort": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item.index",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(_vm._s(_vm.getItemIndex(item)))];
      }
    }, {
      key: "item.term",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-select', {
          staticClass: "rounded-0",
          attrs: {
            "value": item.term,
            "items": _vm.terms,
            "hide-details": "",
            "dense": ""
          },
          on: {
            "input": function input(value) {
              return _vm.setItemValue(item, value, true);
            }
          }
        })];
      }
    }, {
      key: "item.description",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-text-field', {
          staticClass: "rounded-0",
          attrs: {
            "value": item.description,
            "hide-details": "",
            "dense": ""
          },
          on: {
            "input": function input(value) {
              return _vm.setItemValue(item, value);
            }
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('v-icon', {
          on: {
            "click": function click($event) {
              return _vm.removeItem(item);
            }
          }
        }, [_vm._v("mdi-minus-circle-outline")])];
      }
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('table-action-footer', {
    attrs: {
      "selected": _vm.selected,
      "className": "mb-4 no-border-top"
    },
    model: {
      value: _vm.items,
      callback: function callback($$v) {
        _vm.items = $$v;
      },
      expression: "items"
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.addItem
    },
    slot: "right"
  }, [_vm._v("mdi-plus-circle-outline")])], 1)], 1), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "rounded-0",
    attrs: {
      "outlined": "",
      "color": "grey"
    },
    on: {
      "click": _vm.resetItems
    }
  }, [_vm._v("초기화")]), _c('v-btn', {
    staticClass: "rounded-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("수정")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }